import { LEARNING_FIELD_TERMS } from './learning/fieldTerms';
import { REGISTRY_FIELD_TERMS } from './registry/fieldTerms';

/**
 * Прив’язка полів модуля «kb» до понять довідника (значок «?» біля підпису поля).
 * Ключ — `kb.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary).
 * Мапи розділів — у registry/fieldTerms.ts і learning/fieldTerms.ts; підключено в features/knowledge/fieldTerms.ts.
 */
export const KB_FIELD_TERMS: Readonly<Record<string, string>> = { ...REGISTRY_FIELD_TERMS, ...LEARNING_FIELD_TERMS };
